import { takeLatest } from "redux-saga/effects"
import {
  EditFrontlineUsersDataAction,
  getFrontlineUsersDataAction,
  getFrontlineUsersListAction,
  getUserTypeListAction,
  updateUserStatusAction,
  uploadFrontlineUserAction,
  uploadFrontlineBulkUserAction,
  getAdminUsersListAction,
  uploadAdminUserAction,
  getUserMainListAction,
  getRoleUsersListAction,
  getNewRestaurantListAction,
  getAdminUsersDataAction,
  EditAdminUsersDataAction,
  updateAdminUserStatusAction,
  uploadFrontlineBulkUserAdminAction,
  getDashboardStatsAction,
  getVersionListAction,
  addVersionAction,
  getVersionDataAction,
  updateVersionAction,
  deleteVersionAction,
  addNotificationAction,
  getNotificationListAction,
  deleteNotificationAction,
  sendNotificationAction,
  getNotificationsAction,
  EditNotificationAction,
  uploadNotificationImageAction,
  addGiftCardAction,
  getGiftCardListAction,
  deleteGiftCardAction,
  getGiftCardsAction,
  EditGiftCardAction,
  uploadGiftCardImageAction,
  getGamificationDataAction,
  EditGamificationAction,
  getEventDataAction,
  addEventAction,
  deleteEventAction,
  getEventDetailsAction,
  editEventAction
} from "../actions/user"
import {
  EditAdminUsersData,
  EditFrontlineUsersData,
  addVersionItems,
  deleteVersionItem,
  getAdminUsersData,
  getAdminUsersList,
  getAppVersionsList,
  getDashboardStats,
  getFrontlineUsersData,
  getFrontlineUsersList,
  getNewRestaurantList,
  getRoleUsersList,
  getUserMainList,
  getUserTypeList,
  getVersionData,
  updateAdminUserStatus,
  updateUserStatus,
  updateVersionItem,
  uploadAdminUser,
  uploadFrontlineBulkUser,
  uploadFrontlineBulkUserAdmin,
  uploadFrontlineUser,
  addNotification,
  getNotificationList,
  deleteNotification,
  sendNotification,
  getNotifications,
  editNotification,
  uploadNotificationImage,
  addGiftCard,
  getGiftCardList,
  deleteGiftCard,
  getGiftCard,
  EditGiftCard,
  uploadGiftCardImage,
  getGamificationData,
  EditGamification,
  getEventData,
  addEvent,
  deleteEvent,
  getEventDetails,
  editEvent
} from "./user"

export default function* superAdminWatcher() {
  yield takeLatest(getUserTypeListAction, getUserTypeList)
  yield takeLatest(getFrontlineUsersListAction, getFrontlineUsersList)
  yield takeLatest(uploadFrontlineUserAction, uploadFrontlineUser)
  yield takeLatest(getFrontlineUsersDataAction, getFrontlineUsersData)
  yield takeLatest(EditFrontlineUsersDataAction, EditFrontlineUsersData)
  yield takeLatest(updateUserStatusAction, updateUserStatus)
  yield takeLatest(uploadFrontlineBulkUserAction, uploadFrontlineBulkUser)
  yield takeLatest(getAdminUsersListAction, getAdminUsersList)
  yield takeLatest(uploadAdminUserAction, uploadAdminUser)
  yield takeLatest(getUserMainListAction, getUserMainList)
  yield takeLatest(getRoleUsersListAction, getRoleUsersList)
  yield takeLatest(getNewRestaurantListAction, getNewRestaurantList)
  yield takeLatest(getAdminUsersDataAction, getAdminUsersData)
  yield takeLatest(EditAdminUsersDataAction, EditAdminUsersData)
  yield takeLatest(updateAdminUserStatusAction, updateAdminUserStatus)
  yield takeLatest(uploadFrontlineBulkUserAdminAction, uploadFrontlineBulkUserAdmin)
  yield takeLatest(getDashboardStatsAction, getDashboardStats)
  yield takeLatest(getVersionListAction, getAppVersionsList)
  yield takeLatest(addVersionAction, addVersionItems)
  yield takeLatest(getVersionDataAction, getVersionData)
  yield takeLatest(updateVersionAction, updateVersionItem)
  yield takeLatest(deleteVersionAction, deleteVersionItem)
  yield takeLatest(addNotificationAction, addNotification)
  yield takeLatest(getNotificationListAction, getNotificationList)
  yield takeLatest(deleteNotificationAction, deleteNotification)
  yield takeLatest(sendNotificationAction, sendNotification)
  yield takeLatest(getNotificationsAction, getNotifications)
  yield takeLatest(EditNotificationAction, editNotification)
  yield takeLatest(uploadNotificationImageAction, uploadNotificationImage)
  yield takeLatest(addGiftCardAction, addGiftCard)
  yield takeLatest(getGiftCardListAction, getGiftCardList)
  yield takeLatest(deleteGiftCardAction, deleteGiftCard)
  yield takeLatest(getGiftCardsAction, getGiftCard)
  yield takeLatest(EditGiftCardAction, EditGiftCard)
  yield takeLatest(uploadGiftCardImageAction, uploadGiftCardImage)
  yield takeLatest(getGamificationDataAction, getGamificationData)
  yield takeLatest(EditGamificationAction, EditGamification)
  yield takeLatest(getEventDataAction, getEventData)
  yield takeLatest(addEventAction, addEvent)
  yield takeLatest(deleteEventAction, deleteEvent)
  yield takeLatest(getEventDetailsAction, getEventDetails)
  yield takeLatest(editEventAction, editEvent)
}
